import * as React from "react";
import { Box, Typography, Stack, TableHead, TableRow, TableCell, TableBody, useTheme, Button } from "@mui/material";
import ScrollBox from '../../../components/ScrollBox';
import BackButton from "../../../components/BackButton";
import StyledTableContainer from "../../../components/StyledTableContainer";
import BgBoxOld from "../../../components/BgBoxOld";
import { formatDateWithJs, formatUserType, isEmpty, isNotEmpty, NumberFormatter, NumFormatter } from "../../../utils/format";
import LabelTxt from "../../../components/LabelTxt";
import { getSingleDoServ } from "../../../services/po-service";
import { useQuery } from "react-query";
import QueryKey from "../../../utils/QueryKey";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useAuthContext } from "../../../context/AuthContext";
import { useEffect } from "react";
import { customAlert } from "../../../components/notify";
import route from "../../../utils/Routes";
import constants from "../../../utils/Constants";
import LabelTxtFieldInfo from "../../../components/LabelTxtFieldInfo";
import AttachBox from "./AttachBox";




function DoInfoPage() {
    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation()
    const [searchParams] = useSearchParams();
    const { setLoadingScreen, setNavComValue, ctxtUser } = useAuthContext();
    const doIdStrg = searchParams.get("doId");
    const typoHeadStyle = { borderColor: "rgb(0,0,0,0.1)", fontWeight: 500, fontSize: 13, display: "inline-block", width: 160 }
    const typostyle = { fontSize: 12, display: "inline-block" };
    const { isLoading, isError, error, data: doData } = useQuery([QueryKey.doInfo, doIdStrg],
        () => getSingleDoServ(doIdStrg),
        {
            enabled: isNotEmpty(doIdStrg),
            refetchOnMount: true,
            refetchOnWindowFocus: false,
        });


    const columns = [
        {
            id: 'doLineNo',
            label: "S.No",
            align: 'left',
            minWidth: 50,
        },
        {
            id: 'prodName',
            label: "Product",
            align: 'left',
            minWidth: 170
        },
        {
            id: 'amtcProdIdStrg',
            label: "AMTC Ref ID",
            align: 'left',
            minWidth: 100,
        },
        {
            id: 'comProdIdStrg',
            label: "Material Code",
            align: 'left',
            minWidth: 100,
        },
        {
            id: 'orderedQty',
            label: "Ordered Qty",
            align: 'left',
            minWidth: 100,
        },
        {
            id: 'deliveredQty',
            label: "Delivered Qty",
            align: 'left',
            minWidth: 100,
        },
        {
            id: 'prodAttachArr',
            label: "Attachments",
            align: 'left',
            minWidth: 300,
        }
    ];

    useEffect(() => {
        setLoadingScreen(isLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);

    useEffect(() => {
        setNavComValue({ comId: doData?.comId });
        return () => setNavComValue({ comId: "" }); // Reset when leaving the page
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, doData?.comId]);

    function handleProdClick(i) {
        navigate(`${route.aProduct}/?prodId=${i?.amtcProdIdStrg}`);
    }

    function handleEditInvClick() {
        navigate(`${route.aDoEditInv}`, { state: { doIdStrg } });
    }


    if (isError) {
        customAlert(error);
        return <h2>Something went wrong</h2>
    }

    return (
        <Box height={"100%"} width={"100%"} >
            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ width: "100%", mb: 1 }}>
                <Stack width={"30%"}>
                    <BackButton />
                </Stack>
                <Stack width={"40%"} alignItems={"center"}>
                    <Typography style={{ fontSize: 18, fontWeight: 500 }} >Delivery Order</Typography>
                </Stack>
                <Stack width={"30%"} />
            </Stack>
            {doData && <BgBoxOld height={"93%"} py={0.2} px={0.01}>
                <ScrollBox height={"100%"}>
                    <Box height={"100%"} width={"100%"} px={1} position={"relative"}>
                        <Stack width={"100%"} mb={1} px={2} mt={1}>
                            <Typography sx={{ fontSize: 16, fontWeight: 500 }}>DO ID : {doData?.doIdStrg} </Typography>
                            <Stack width={"100%"} direction={"row"} gap={4} mt={1} >
                                <Stack width={"33%"} gap={0.5}>
                                    <LabelTxt typoname={"DO Number"} typodetail={doData?.actDoNum ?? "NA"} overflow={30} namestyle={typoHeadStyle} detailstyle={typostyle} />
                                    <LabelTxt typoname={"Order Request ID"} typodetail={doData?.poIdStrg ?? "NA"} overflow={30} namestyle={typoHeadStyle} detailstyle={typostyle} />
                                    <LabelTxt typoname={"PO Number"} typodetail={doData?.actPoNum ?? "NA"} overflow={30} namestyle={typoHeadStyle} detailstyle={typostyle} />
                                    <Stack mt={1}>
                                        <LabelTxtFieldInfo fontSize={13} defaultValue={doData.dispatchLocation} readOnly={true} name="dispatchLocation" title="Delivery Location" width={"100%"} borderRadius={1} rows={4} multiline={true} height={87} />
                                    </Stack>
                                </Stack>
                                <Stack width={"33%"} gap={0.5}>
                                    <LabelTxt typoname={"Created By"} typodetail={doData?.createdByUser} overflow={30} namestyle={typoHeadStyle} detailstyle={typostyle} />
                                    <LabelTxt typoname={"Delivered At"} typodetail={formatDateWithJs(doData?.deliveredAt)} overflow={20} namestyle={typoHeadStyle} detailstyle={typostyle} />
                                    <LabelTxt typoname={"Payment Status"} typodetail={formatUserType(doData?.pymtStatus)} overflow={20} namestyle={typoHeadStyle} detailstyle={typostyle} />
                                    <Stack mt={1}>
                                        <LabelTxtFieldInfo fontSize={13} defaultValue={doData.doDesc} readOnly={true} name="doDesc" title="Description" width={"100%"} borderRadius={1} rows={4} multiline={true} height={87} />
                                    </Stack>
                                </Stack>
                                <Stack width={"33%"} gap={0.5}>
                                    <LabelTxt typoname={"Invoice No"} typodetail={doData?.invNo ?? "NA"} overflow={30} namestyle={typoHeadStyle} detailstyle={typostyle} />
                                    <LabelTxt typoname={"Invoice Date"} typodetail={formatDateWithJs(doData?.invDate)} overflow={20} namestyle={typoHeadStyle} detailstyle={typostyle} />
                                    <LabelTxt typoname={"Invoice Updated By"} typodetail={doData?.invUpdatedByUser ?? "NA"} overflow={30} namestyle={typoHeadStyle} detailstyle={typostyle} />
                                </Stack>
                            </Stack>
                        </Stack>

                        <StyledTableContainer height={"90%"} isStickyHeader={true}>
                            <TableHead>
                                <TableRow >
                                    {columns.map((column) => (
                                        <TableCell align={column.align} style={{ minWidth: column.minWidth }} key={column.id} sx={{ backgroundColor: "rgba(253, 240, 213, 1)" }}>
                                            {column.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(doData?.prods || []).map((i, index) => {
                                    return (
                                        <React.Fragment key={i?.id}>
                                            <TableRow hover tabIndex={-1}
                                                sx={{ height: 33 }} >
                                                {columns.map((column) => {
                                                    const value = i[column.id];
                                                    switch (column.id) {
                                                        case "prodName":
                                                        case "amtcProdIdStrg":
                                                            return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                                {isEmpty(value) ? "NA" : <Button variant="text" sx={{ color: "black", ml: -1, fontSize: 12 }}
                                                                    onClick={() => handleProdClick(i)}>
                                                                    {value}
                                                                </Button>}
                                                            </TableCell>
                                                        case "doLineNo":
                                                        case "orderedQty":
                                                        case "deliveredQty":
                                                            return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                                {NumFormatter(value)}
                                                            </TableCell>
                                                        case "unitPrice":
                                                        case "tax":
                                                        case "totalPrice":
                                                            return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                                {NumberFormatter(value)}
                                                            </TableCell>
                                                        case "expecDelDate":
                                                            return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                                {formatDateWithJs(value)}
                                                            </TableCell>
                                                        case "prodAttachArr":
                                                            return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                                <AttachBox files={value} />
                                                            </TableCell>
                                                        default:
                                                            return (
                                                                <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                                    {(value === null || value === "" || value === "null") ? "-" : value}
                                                                </TableCell>
                                                            );
                                                    }
                                                })}
                                            </TableRow>
                                        </React.Fragment>
                                    );
                                })}
                            </TableBody>
                        </StyledTableContainer>
                        <Box my={4} />
                        {(ctxtUser?.userType === constants.accounts || ctxtUser?.userType === constants.admin) && <Button variant='outlined' onClick={handleEditInvClick} sx={{
                            fontSize: 13, color: theme?.palette?.custom?.btn, borderColor: theme?.palette?.custom?.btn, height: 30,
                            position: "absolute", top: 8, right: 18
                        }}>
                            Update Invoice</Button>}
                    </Box>
                </ScrollBox>
            </BgBoxOld>}
        </Box>
    );
}
export default DoInfoPage;